import type { ChangeEvent } from 'react';

/** E-mail digitado: sem espaco e so minusculas. */
export function normalizarEmailDigitado(valor: string): string {
  return valor.replace(/\s/g, '').toLowerCase();
}

/** Ajusta o valor do evento antes do form ler, para o campo mostrar o texto limpo. */
export function aplicarEmailDigitado(e: ChangeEvent<HTMLInputElement>): void {
  const norm = normalizarEmailDigitado(e.target.value);
  if (e.target.value !== norm) {
    e.target.value = norm;
  }
}
